<template>
    <div>
        <FullCalendar ref="fullCalendar"
                      :schedulerLicenseKey="schedulerLicenseKey"
                      :plugins="plugins"
                      :timeZone="timeZone"
                      :locale="locale"
                      :defaultView="defaultView"
                      :aspectRatio="aspectRatio"
                      :header="header"
                      :selectable="editable"
                      :selectHelper="editable"
                      :editable="editable"
                      :resourceLabelText="resourceLabelText"
                      :resources="resources"
                      :events="events"
                      :views="fc_views"
                      :buttonText="buttonText"
                      @select="select"
                      @eventClick="eventClick"
                      @eventResize="eventResize"
                      @eventDrop="eventDrop"
        ></FullCalendar>
    </div>
</template>

<script>
    import moment from 'moment';
    import FullCalendar from '@fullcalendar/vue';
    import interactionPlugin from '@fullcalendar/interaction';
    import momentPlugin from '@fullcalendar/moment';
    import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
    import axios from 'axios';

    export default {
        components: {
            FullCalendar,
        },
        props: {
            editable: {
                type: Boolean,
                default: 'false',
            },
            shop: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
                plugins: [interactionPlugin, momentPlugin, resourceTimelinePlugin],
                timeZone: 'Asia/Tokyo',
                locale: 'ja',
                defaultView: 'resourceTimelineDay',
                aspectRatio: 1.5,
                header: {
                    left: 'prev,next',
                    center: 'title',
                    right: 'resourceTimelineDay,resourceTimelineWeek,resourceTimelineMonth'
                },
                fc_views: {
                    month: {
                        titleFormat: 'YYYY年M月',
                    },
                    week: {
                        titleFormat: 'YYYY年M月D日',
                    },
                    day: {
                        titleFormat: 'YYYY年M月D日(ddd)',
                    },
                },
                buttonText: {
                    today:    '今日',
                    month:    '月',
                    week:     '週',
                    day:      '日'
                },
                resourceLabelText: '従業員',
                resources: [],
                events: '',
                intervalId: undefined
            }
        },
        mounted() {
            this.resources = '/api/v1/shops/' + this.shop + '/shifts/resources';
            this.events = '/api/v1/shops/' + this.shop + '/shifts/events';

            this.intervalId = setInterval(() => {
                if(!this.editable){
                    this.refetchEvents();
                }
            }, 30 * 1000);
        },
        methods: {
            select(arg) {
                console.log(arg);

                let event = {
                    start: arg.start,
                    end: arg.end,
                };

                this.addEvent(event, arg.resource.id);
            },

            eventClick(arg) {
                console.log(arg);

                let start = moment(arg.event.start);
                let end = moment(arg.event.end);
                let work = moment.duration(end.diff(start));

                let html = '出社時刻：' + start.utc().format('YYYY年MM月DD日 hh:mm') + '<br>'
                    + '退社時刻：' + end.utc().format('YYYY年MM月DD日 hh:mm') + '<br>'
                    + '<br>'
                    + '勤務時間：' + work.hours() + '時間' + work.minutes() + '分';

                let title = this.$refs.fullCalendar.getApi().getResourceById(arg.event._def.resourceIds[0]).title;

                if (this.editable) {
                    this.$swal({
                        type: 'info',
                        title: title,
                        html: html,
                        showCancelButton: true,
                        confirmButtonText: '削除',
                        cancelButtonText: '閉じる',
                        reverseButtons: true,
                    }).then((result) => {
                        if (result.value) {
                            this.$swal({
                                type: 'warning',
                                title: 'Warning',
                                text: '本当に削除してもよろしいでしょうか？',
                                showCancelButton: true,
                                confirmButtonText: 'はい',
                                cancelButtonText: 'いいえ',
                            }).then((result) => {
                                if (result.value) {
                                    this.removeEvent(arg.event);
                                }
                            });
                        }
                    });
                } else {
                    this.$swal({
                        type: 'info',
                        title: title,
                        html: html,
                    })
                }
            },

            eventResize(arg) {
                console.log('Resize');
                console.log(arg);
                //console.log(arg.event.id);
                this.changeEvent(arg.event);
            },

            eventDrop(arg) {
                console.log('Drop');
                console.log(arg);
                //console.log(arg.event.id);
                let resource_id = arg.newResource ? arg.newResource.id : null;
                this.changeEvent(arg.event, resource_id);
            },


            addEvent(event, resource_id) {
                console.log(event);
                event.resourceId = resource_id;

                axios.post('/api/v1/shops/' + this.shop + '/shifts', event)
                    .then(response => this.refetchEvents())
                    .catch(error => this.error(error));
            },

            changeEvent(event, resource_id) {
                console.log(event);

                let param = {
                    start: event.start,
                    end: event.end,
                };

                if (resource_id) {
                    param.resourceId = resource_id;
                }

                axios.put('/api/v1/shops/' + this.shop + '/shifts/' + event.id, param)
                    .then(response => this.refetchEvents())
                    .catch(error => this.error(error));
            },

            removeEvent(event) {
                axios.delete('/api/v1/shops/' + this.shop + '/shifts/' + event.id)
                    .then(response => event.remove())
                    .catch(error => this.error(error));
            },

            refetchEvents() {
                this.$refs.fullCalendar.getApi().refetchEvents();
            },

            error(error) {
                console.log(error);
                this.$swal({
                    type: 'error',
                    title: 'Error',
                    text: 'エラーが発生しました',
                });
            }
        },
    }
</script>

<style scoped>
    @media screen and (max-width: 480px) {
        /deep/ .fc-toolbar {
            flex-wrap: wrap;
        }
    }
</style>
